import { Filter } from '@cubejs-client/core';
import { useCubeQuery } from '@cubejs-client/react';

import { CubeQueryData } from '~/common/types';
import { SummaryPurchaseRequisitionItemField } from '~/common/types/cubes/SummaryPurchaseRequisitionItem';

interface UsePurchaseRequisitionCubeDataResult {
  purchaseRequisitionItems: CubeQueryData[] | undefined;
  totalValue: number | undefined;
  isLoading?: boolean;
}

export const usePurchaseRequisitionCubeData = (id: string): UsePurchaseRequisitionCubeDataResult => {
  const filters: Filter[] = [
    {
      member: SummaryPurchaseRequisitionItemField.ID,
      operator: 'equals',
      values: [id],
    },
  ];

  const purchaseRequisition = useCubeQuery<CubeQueryData>({
    dimensions: [
      SummaryPurchaseRequisitionItemField.ID,
      SummaryPurchaseRequisitionItemField.TITLE,
      SummaryPurchaseRequisitionItemField.DESCRIPTION,
      SummaryPurchaseRequisitionItemField.SUPPLIER_NAME,
      SummaryPurchaseRequisitionItemField.UNIT,
      SummaryPurchaseRequisitionItemField.QUANTITY,
      SummaryPurchaseRequisitionItemField.PRICE_PER_UNIT,
      SummaryPurchaseRequisitionItemField.CURRENCY,
      SummaryPurchaseRequisitionItemField.EXTERNAL_ID,
      SummaryPurchaseRequisitionItemField.LINE_ITEM_NUMBER,
      SummaryPurchaseRequisitionItemField.SUMMARY,
      SummaryPurchaseRequisitionItemField.ITEM_ID,
      SummaryPurchaseRequisitionItemField.SUPPLIER_ID,
    ],
    order: {
      [SummaryPurchaseRequisitionItemField.LAST_CHANGED]: 'asc',
    },
    measures: [SummaryPurchaseRequisitionItemField.COUNT, SummaryPurchaseRequisitionItemField.TOTAL_VALUE],
    filters,
  });

  const purchaseRequisitionTotal = useCubeQuery({
    measures: [SummaryPurchaseRequisitionItemField.TOTAL_VALUE],
    filters,
    order: {
      [SummaryPurchaseRequisitionItemField.TOTAL_VALUE]: 'desc',
    },
  });

  const purchaseRequisitionItems: CubeQueryData[] | undefined = purchaseRequisition.resultSet?.rawData();

  const totalValue = purchaseRequisitionTotal.resultSet?.totalRow()[SummaryPurchaseRequisitionItemField.TOTAL_VALUE];
  return {
    purchaseRequisitionItems,
    totalValue,
    isLoading: purchaseRequisition.isLoading || purchaseRequisitionTotal.isLoading,
  };
};
